import React                from 'react';
import PropTypes            from 'prop-types';
import UiKit                from '../../uikit';
import {
    Container,
    PageButton
}                           from './components';
import { useTranslate }     from '../../../hooks/use';

const Pagination = (props) => {
    const p     = props;
    const t     = useTranslate();

    const createPageButtons = () => {
        if (p.pageCount < 1) return

        let buttons         = []
        const start         = p.currentPage > 5 ? p.currentPage - 3 : 2

        const maxNumber     = (p.currentPage + 3) > p.pageCount
                                ? p.pageCount
                                : p.currentPage < 4 ? 5 : + p.currentPage + 3

        const maxNumberShow = p.pageCount <= 4
                                ? p.pageCount
                                : maxNumber

        const rangeOfPages  = Array.from({ length: maxNumberShow - start }, (_, i) => start + i);     

        buttons.push(
            <PageButton 
                pageNumber      = { 1 }
                key             = { 1 }
                currentPage     = { p.currentPage }
                changePage      = { () => changePage(1) }
            />
        )

        if (p.currentPage > 5) {
            buttons.push(
                <PageButton 
                    pageNumber  = { <p>...</p> }
                    key         = 'firstDot'
                    currentPage = { p.currentPage }
                    changePage  = { () => changePage(1) }
                /> 
            )
        }

        buttons.push(
            rangeOfPages.map(i => (
                <PageButton 
                    key         = { i }
                    pageNumber  = { i }
                    currentPage = { p.currentPage }
                    changePage  = { () => changePage(i) }
                />
            ))
        )

        if (p.currentPage + 3 < p.pageCount && p.pageCount > 6) {
            buttons.push(
                <PageButton 
                    pageNumber  = { <p>...</p> }
                    key         = 'lastDot'
                    currentPage = { p.currentPage }
                    changePage  = { () => changePage(p.pageCount) }
                />
            )
        }

        if (p.pageCount > 1) {
            buttons.push(
                <PageButton 
                    pageNumber  = { p.pageCount }
                    key         = { p.pageCount }
                    currentPage = { p.currentPage }
                    changePage  = { () => changePage(p.pageCount) }
                />
            )
        }

        return buttons
        
    }

    const changePage = page => {
        if(typeof p.onPageChange === 'function') {
            p.onPageChange(page);
        }
    }

    return (
        <Container>
            <div 
                onClick     = { () => changePage(p.currentPage - 1) } 
                className   = "pagination-buttons s__mr5 mr57"
            >
                <UiKit.Icon icon="line-arrow-left" className="text16" />
                <span className="ml10">{ t('Static_Label_Prev') }</span>
            </div>
            { createPageButtons() }
            <div 
                onClick     = { () => changePage(p.currentPage + 1) }
                className   = "pagination-buttons s__ml5 ml57"
            >
                <span className="mr7">{ t('Static_Label_Next') }</span>
                <UiKit.Icon icon="line-arrow-right" className="text28" />
            </div>
        </Container>
    )
}

Pagination.propTypes = {
    currentPage         : PropTypes.number.isRequired,
    pageCount           : PropTypes.number.isRequired,
    onPageChange        : PropTypes.func,
};

Pagination.defaultProps = {
    currentPage         : 1,
    pageCount           : 10,
    onPageChange        : () => {},
};

export default Pagination